export type CancelationReq = {
  orderId: string;
  simIdx?: number;
  isCancel: boolean;
  isRefund?: boolean;
}

export function wholeOrderCancellationRequest(
  orderId: string,
  isCancel: boolean,
  isRefund: boolean,
): CancelationReq {
  return {
    orderId,
    isCancel,
    isRefund: isCancel ? isRefund : false,
  };
}

export function itemCancellationRequest(
  orderId: string,
  simIdx: number,
  isCancel: boolean,
): CancelationReq {
  return { orderId, simIdx, isCancel };
}
